// 多选题模块
<template>
  <div style="margin-top:10px">
    <div class="issueTitle">
      Q{{ index }}:{{ infoData.contentTitle }}({{
          $store.state.select.optionType[infoData.type].name
        }})
    </div>
    <div style="display: flex;">
      <bar-charts
      :echartsData="infoData.investigationStatisticsSubbs">
      </bar-charts>
      <el-table
        :data="infoData.investigationStatisticsSubbs"
        max-height="250px"
        border
        :summary-method="getSummaries"
        show-summary
        style="margin:0px 10px 0px 10px"
      >
        <el-table-column label="序号" width="50">
            <template slot-scope="scope">
                {{ String.fromCharCode(64 + parseInt(scope.$index + 1)) }}
            </template>
        </el-table-column>
        <el-table-column prop="option" label="选项" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="cot" label="计数"> </el-table-column>
        <el-table-column prop="scale" label="占比">
          <template slot-scope="scope"> {{ scope.row.scale * 100 }}% </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin:10px 10px 0px 10px">
      <el-table
        :data="infoData.investigationStatisticsSubas"
        max-height="300px"
        border
      >
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="schoolName" label="学校" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userName" label="回答人"> </el-table-column>
        <el-table-column prop="answer" label="选项">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import BarCharts from './BarCharts.vue'
export default {
  components: { BarCharts },
  name: 'MulitSelect',
  props: {
    infoData: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {}
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            var value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (index === 3) {
            sums[index] = sums[index] * 100 + ' %'
          } else {
            sums[index] += ' '
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
  },
}
</script>
<style scoped>
.issueTitle {
  margin-left: 20px;
  font-size: 18px;
  font-weight:bold;
}
</style>
